import { Badge } from './Badge';

export const PremiumBadge = () => (
  <Badge className='bg-blue-50 text-jw-blue ring-blue-700/10'>
    Premium
  </Badge>
);
